
import Home from './components/frontend/Home';
import About from './components/frontend/About';
import Contact from './components/frontend/ContactWrapper';
import Events from './components/frontend/EventsWrapper';
import Help from './components/frontend/Help';

import Radio from './components/frontend/Radio';
import Podcasts from './components/frontend/Podcasts';

const routes = [
	{
		path: '/',
		element: <Home />,
		type: 'public',
	}, {
		path: '/home',
		element: <Home />,
		type: 'public',
	}, {
		path: '/about',
		element: <About />,
		type: 'public',
	}, {
		path: '/contact',
		element: <Contact />,
		type: 'public',
	}, {
		path: '/events',
		element: <Events />,
		type: 'public',
	}, {
		path: '/help',
		element: <Help />,
		type: 'public',
	}, {
		path: '/radio',
		element: <Radio />,
		type: 'public',
	}, {
		path: '/podcasts',
		element: <Podcasts />,
		type: 'public',
	},
	// And so on.

	//Radios
];

export default routes;